import React from 'react';
import './VideoPlayer.css';

export const ImageBackground = (props) => {
    return (
        <div className={'video-bg'}>
            {!props.isPlaying && (
                <img alt='image' src={props.imageUrl} className='thumbnail' />
            )}
        </div>
    )
}